module.exports = __webpack_public_path__ + "img/@temp1.62f66d94.png";